import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const promoterFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      icon: Images.iconTagMusic,
      width: 20,
      height: 20,
      title: "Music",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Electronic",
          tagId: 301,
        },
        {
          id: 2,
          label: "Pop",
          tagId: 302,
        },
        {
          id: 3,
          label: "Rock",
          tagId: 303,
        },
        {
          id: 4,
          label: "Hip-Hop",
          tagId: 304,
        },
        {
          id: 5,
          label: "R&B",
          tagId: 305,
        },
        {
          id: 6,
          label: "Reggae",
          tagId: 306,
        },
        {
          id: 7,
          label: "Jazz",
          tagId: 307,
        },
        {
          id: 8,
          label: "Blues",
          tagId: 308,
        },
        {
          id: 9,
          label: "Metal",
          tagId: 309,
        },
        {
          id: 10,
          label: "Punk",
          tagId: 310,
        },
        {
          id: 11,
          label: "Country",
          tagId: 311,
        },
        {
          id: 12,
          label: "Folk",
          tagId: 312,
        },
        {
          id: 13,
          label: "Latin",
          tagId: 313,
        },
        {
          id: 14,
          label: "Classical",
          tagId: 314,
        },
        {
          id: 15,
          label: "Religious",
          tagId: 315,
        },
      ],
      selectedList: [],
    },
    {
      icon: Images.iconTagActivity,
      width: 20,
      height: 20,
      title: "Activity",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Promoting",
        },
        {
          id: 2,
          label: "Inactive",
        },
      ],
      selectedList: [],
    },
    {
      icon: Images.iconCalendarColored,
      width: 20,
      height: 20,
      title: "Date",
      isHide: false,
      // isHide: !isSearch,
      isDate: true,
      dateType: "anytime",
    },
  ];
};
